import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { PortatilUltimaTransmision } from '../../../../../../_entities/Portatiles/Portatil';
import { MapaService } from '../../../../services/mapa.service';
import { PortatilesService } from '../../../../services/portatiles.service';
import { HistoricoPosicionesPortatilesComponent } from '../../../popups/portatiles/historico-posiciones-portatiles/historico-posiciones-portatiles.component';

@Component({
  selector: 'kt-portatil-modal',
  templateUrl: './portatil-modal.component.html',
  styleUrls: ['./portatil-modal.component.scss']
})
export class PortatilModalComponent implements OnInit {

  public portatiles: PortatilUltimaTransmision[];
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	 isDiabled: boolean = true;
	public datosReporte = [];

	constructor(private activosService: PortatilesService,
		private mapaService: MapaService,
		public dialogRef: MatDialogRef<PortatilModalComponent>,
		public dialog: MatDialog) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.obtenerActivos();
	}

	obtenerActivos() {
		this.activosService.obtenerUltimaTransmisionPortatiles().subscribe(
			(portatiles: PortatilUltimaTransmision[]) => {
				portatiles.map(activo => {
					activo.bateria = activo.bateria + '%'
					switch (activo.estatus) {
						case 0:
							activo.estatus = 'Inactivo';
							break;
						case 1:
							activo.estatus = 'Activo';
							break;
						default:
							break;
					}
				})
				this.portatiles = portatiles;
				this.portatiles.forEach(activo => {
					this.datosReporte.push({
						'Batería': activo.bateria,
						'Económico': activo.economico,
						'Número de Serie': activo.numeroSerie,
						'Estatus': activo.estatus,
						'Descripcion': activo.descripcion,
						'Modelo': activo.modelo,
						'IMEI': activo.imei.toString()
					});
				});
				if(this.datosReporte.length > 0) {
					this.isDiabled = false;
				}
			}
		)
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	reportePosiciones(data: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "58%";
		dialogConfig.data = data;
		this.dialogRef.close();
		this.dialog.open(HistoricoPosicionesPortatilesComponent, dialogConfig);
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.ocultarUbicadorLayer();
		this.dialogRef.close();
		this.mapaService.verActivo(data);
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
}


